const ShippingInTransitIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
    >
        <title>Pakke med fartsstriper bak</title>
        <path
            d="M0.766113 13.222L3.70311 14.709"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.859863 9.23401L3.67186 10.74"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.04492 5.918L3.73392 6.959"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.8589 5.151L19.1089 9.366"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.0619 3.51401L7.87391 6.67601C7.52891 6.85498 7.23995 7.12563 7.03882 7.4582C6.8377 7.79077 6.73219 8.17236 6.73391 8.56101V15.44C6.73228 15.8288 6.83794 16.2104 7.03925 16.543C7.24056 16.8756 7.52972 17.1462 7.87491 17.325L14.0619 20.486C14.3474 20.6324 14.6636 20.7087 14.9844 20.7087C15.3052 20.7087 15.6214 20.6324 15.9069 20.486L22.0939 17.325C22.439 17.1461 22.728 16.8755 22.9291 16.5429C23.1303 16.2103 23.2357 15.8287 23.2339 15.44V8.56101C23.2358 8.17232 23.1304 7.79063 22.9293 7.45802C22.7281 7.12541 22.4391 6.8548 22.0939 6.67601L15.9069 3.51401C15.6213 3.36812 15.3051 3.29205 14.9844 3.29205C14.6637 3.29205 14.3475 3.36812 14.0619 3.51401V3.51401Z"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.908 7.42499L14.984 11.473L7.06104 7.42499"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.9839 11.473V20.709"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.1089 9.366V12.278"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ShippingInTransitIcon;
